module.exports = __webpack_public_path__ + "static/media/stepCircleWrong.d2c744f0.svg";